import * as Yup from "yup";

const AddressFormSchema = () => {
  return Yup.object().shape({
    firstName: Yup.string()
      .min(3, "Alias musi mieć co najmniej 3 znaki")
      .max(20, "Alias może mieć maksymalnie 20 znaków")
      .required("Alias jest wymagany"),
    email: Yup.string()
      .email("Nieprawidłowy adres email")
      .required("Email jest wymagany"),
    message: Yup.string()
      .min(10, "Wiadomość musi mieć co najmniej 10 znaków")
      .max(1000, "Wiadomość może mieć maksymalnie 1000 znaków")
      .required("Wiadomość jest wymagana"),
    terms: Yup.boolean().oneOf([true], "Musisz zaakceptować regulamin"),
  });
};

export default AddressFormSchema;
